import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { DrwList, MpDrwList } from 'models/mp/MpDrw';
import { callApi } from 'utils/ApiUtil';

/**
 * 제작사양서 선택 팝업 리스트 조회
 * @param searchParam
 */
export const getDrwList = async (searchParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/mp/getDrwList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...searchParam,
    }),
  };
  const response: CommonResponse<DrwList[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as DrwList[];
};

/**
 * 제작사양서 조회 팝업 리스트
 * @param searchParam
 */
export const getMpDrwList = async (searchParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/mp/getMpDrwList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...searchParam,
    }),
  };
  const response: CommonResponse<MpDrwList[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MpDrwList[];
};

/**
 * 제작사양서 개정완료 처리 (IF 처리 전 임시사용)
 * TODO FDM IF 작업 완료 후 삭제 예정
 * @param mpItemId
 */
export const completeSpshRev = async (mpItemId: string) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/mp/${mpItemId}/completeSpshRev`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<void> = await callApi(request);
  return response;
};
